import { render, staticRenderFns } from "./Mockups.vue?vue&type=template&id=acbc925e&scoped=true"
import script from "./Mockups.vue?vue&type=script&lang=js"
export * from "./Mockups.vue?vue&type=script&lang=js"
import style0 from "./Mockups.vue?vue&type=style&index=0&id=acbc925e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbc925e",
  null
  
)

export default component.exports